import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";

const BcrumbBannerSmartTech = ({
  title,
  noimg,
  paragraph,
  mainThumb,
  bannerData,
  color,
  titleCategory,
  page, // Add page prop for breadcrumb
}) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const responsivePadding =
    windowWidth <= 768 ? "140px 0 70px" : "200px 0 70px";

  // Normalize mainThumb to always be an array
  const thumbImages = Array.isArray(mainThumb)
    ? mainThumb.map((item) => item.mainThumb || item)
    : mainThumb
    ? [mainThumb]
    : [];

  // Create a default slides array using the single item props if bannerData is not provided
  const slides = bannerData || [
    {
      title: title,
      paragraph: paragraph,
      mainThumbs: thumbImages,
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows: false,
    pauseOnHover: false,
    dotsClass: "slick-dots custom-dots",
  };

  return (
    <div
      className="breadcrum-area smart-tech-banner single-breadcrumb-smart-tech"
      style={{ padding: responsivePadding }}
    >
      <div className="container">
        {/* Add Breadcrumb Navigation */}
        <div className="breadcrumb" style={{ marginBottom: "20px" }}>
          <ul className="list-unstyled">
            <li>
              <Link
                to={process.env.PUBLIC_URL + "/"}
                style={{ color: "var(--color-text-dark)" }}
              >
                Home
              </Link>
            </li>
            {page && (
              <li
                className="active"
                dangerouslySetInnerHTML={{ __html: page }}
              ></li>
            )}
          </ul>
          {titleCategory && (
            <h1
              className="title h2"
              dangerouslySetInnerHTML={{ __html: titleCategory }}
              style={{
                color: "",
                marginBottom: "60px",
              }}
            ></h1>
          )}
        </div>
        {slides.map((slide, index) => (
          <div key={index}>
            <div className="row align-items-center justify-content-center">
              <div className={`${noimg ? "col-lg-7" : "col-lg-6"} text-center`}>
                <div className="section-heading heading-left">
                  <h1
                    style={{ color: color }}
                    className="title h2"
                    dangerouslySetInnerHTML={{ __html: slide.title }}
                  ></h1>
                  <p dangerouslySetInnerHTML={{ __html: slide.paragraph }}></p>
                </div>
              </div>
              {!noimg && (
                <div className="col-lg-6 d-flex justify-content-center">
                  <Slider
                    {...settings}
                    className="w-100"
                    style={{ maxWidth: "400px" }}
                  >
                    {slide.mainThumbs &&
                      slide.mainThumbs.map((thumb, thumbIndex) => (
                        <div
                          key={thumbIndex}
                          className="smart-tech-banner-thumbnail text-center"
                        >
                          <img
                            src={process.env.PUBLIC_URL + thumb}
                            alt="Illustration"
                            className="smart-tech-banner-image mx-auto"
                            style={{
                              maxWidth: "100%",
                              height: "auto",
                              display: "block",
                            }}
                          />
                        </div>
                      ))}
                  </Slider>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// Add default props
BcrumbBannerSmartTech.defaultProps = {
  title: "",
  paragraph: "",
  mainThumb: [],
};

export default BcrumbBannerSmartTech;
